import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";

export interface Company {
    id: number,
    guid: string,
    status: number,
    membershipType: number,
    name: string,
    wpId: number
}

export enum MembershipType {
    NonMember = 0, Logo = 1, NonVoting = 2, EndUser = 3, Corporate = 4
}

export const MembershipTypeStrings = ["NonMember", "Logo", "NonVoting", "EndUser", "Corporate"];

export enum CompanyStatus {
    Unknown = 0, Active = 1, Disabled = 2
}

export const CompanyStatusStrings = ["Unknown", "Active", "Disabled"];

export const getCompanies = (abortController: AbortController): Promise<ApiResponse<Company[]>> =>
    httpGet('/api/company', abortController);

export const getCompanyWpID = (companyWpId: number, abortController: AbortController): Promise<ApiResponse<Company>> =>
    httpGet(`/api/company/getfromwpid/${companyWpId}`, abortController);

export const updateCompanyData = (data: Company, abortController: AbortController): Promise<ApiResponse<Company>> =>
    httpPost(`/api/company/update`, data, abortController);